import { CommonModule } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	NgModule,
	TemplateRef,
	ViewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

import { QuotaTypeEnum } from '@reach/interfaces/quotas/quota-type.enum';

import { QuotaApiService } from '~app-client/api/services';
import { QuotaService } from '~app-client/core/services';
import { ReachModalsService } from '~app-client/modals/services';
import { Implicit } from '~app-client/modals/types';

@Component({
	standalone: false,

	selector: 'chat-ai-conversations-exceeded',
	templateUrl: './chat-ai-conversations-exceeded.component.html',
	host: { class: 'hidden' },
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'error-modals' } }],
})
export class ChatAiConversationsExceededComponent implements AfterViewInit {
	@ViewChild('tpl')
	private tpl: TemplateRef<Implicit<void>>;

	private readonly quotaService = inject(QuotaService);

	private readonly $quota = toSignal(this.quotaService.quotas$);

	public readonly $quotaNodes = computed(() => {
		const quota = this.$quota();
		if (!quota) {
			return null;
		}
		const { total, used } = quota[QuotaTypeEnum.CHAT_KNOWLEDGE_CONVERSATIONS];
		return { total, used };
	});

	constructor(
		private readonly quotaApi: QuotaApiService,
		private readonly modalsService: ReachModalsService,
		private readonly router: Router
	) {}

	async ngAfterViewInit(): Promise<void> {
		this.modalsService.openModal(this.tpl, null, {
			closeOnOutsideClick: false,
		});

		await this.quotaService.load(true);
	}

	public async confirm(): Promise<void> {
		await this.router.navigate(['/', 'home', 'profile', 'usage']);
		this.cancel();
	}

	public cancel(): void {
		this.modalsService.closeModal();
	}
}

@NgModule({
	declarations: [ChatAiConversationsExceededComponent],
	imports: [CommonModule, TranslocoModule],
	exports: [ChatAiConversationsExceededComponent],
})
export class ChatAiConversationsExceededModule {}
